"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalysisTriggerRunPolicySchema = exports.AnalysisTriggerRunPolicy = exports.AnalysisLifecycleStageSchema = exports.AnalysisLifecycleStage = void 0;
const zod_1 = require("zod");
var AnalysisLifecycleStage;
(function (AnalysisLifecycleStage) {
    AnalysisLifecycleStage["PackageUnderstanding"] = "package-understanding";
    AnalysisLifecycleStage["PreAnalysis"] = "pre-analysis";
    AnalysisLifecycleStage["Analysis"] = "analysis";
    AnalysisLifecycleStage["PostAnalysis"] = "post-analysis";
})(AnalysisLifecycleStage || (exports.AnalysisLifecycleStage = AnalysisLifecycleStage = {}));
exports.AnalysisLifecycleStageSchema = zod_1.default.nativeEnum(AnalysisLifecycleStage);
var AnalysisTriggerRunPolicy;
(function (AnalysisTriggerRunPolicy) {
    AnalysisTriggerRunPolicy["Automatic"] = "automatic";
    AnalysisTriggerRunPolicy["OnDemand"] = "on_demand";
})(AnalysisTriggerRunPolicy || (exports.AnalysisTriggerRunPolicy = AnalysisTriggerRunPolicy = {}));
exports.AnalysisTriggerRunPolicySchema = zod_1.default.nativeEnum(AnalysisTriggerRunPolicy);
//# sourceMappingURL=lifecycle.js.map